import React from "react";

import { useNavigate, useParams } from "react-router-dom";
import { useState } from "react";
import { SignInput } from "../../components/Sign/SignForms";
import Loading from "../../components/Buttons/Loading";
import { useTranslation } from "react-i18next";
import "./styles.css";
import useApi from "../../hooks/useApi";
import { updatePassword } from "../../api/FlaskAPI";
import { toast } from "react-toastify";
function ResetPass() {
  const { t } = useTranslation();
  const resetRequest = useApi(updatePassword);
  const [formData, setFormData] = useState({
    password: "",
    confirmPassword: "",
    errors: {},
  });
  const navigate = useNavigate();
  const { reset_token } = useParams();
  console.log("userrrrrrrrrrrrrffffffffff", reset_token);

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  const handleReset = async () => {
    const { password, confirmPassword } = formData;
    if (!password || !confirmPassword) {
      setFormData({
        ...formData,
        errors: {
          password: !password ? t("Sign.password_required") : "",
          confirmPassword: !confirmPassword ? t("Sign.confirm_required") : "",
        },
      });
      return;
    }
    //remove previous error when all pass
    setFormData({
      ...formData,
      errors: {},
    });
    //check passwords are a match
    if (password !== confirmPassword) {
      setFormData({
        ...formData,
        errors: {
          confirmPassword: t("Sign.passwords_match_required"),
        },
      });
      return;
    }
    const res = await resetRequest.request(
      { password, token: reset_token },
      false
    );
    console.log(res)
    //connection issue or failure
    if (!res || res?.status !== 200) {
      toast.error(t("request_error"));
      return;
    }

    //success
    toast.success(t("Sign.reset_success"));
    //go to home
    setTimeout(() => {
      navigate("/");
    }, 4000);
  };
  return (
    <div className="reset-container">
      <div className="reset-card">
        <div className="reset-form" style={{ background: "transparent" }}>
          <h3>{t("Sign.forgot")}</h3>

          <span>{t("Sign.enter_new_password")}</span>

          <SignInput
            name="password"
            value={formData.password}
            error={formData.errors?.password}
            onChange={onChange}
            type="password"
            placeholder={t("Sign.password")}
          />

          <SignInput
            name="confirmPassword"
            onChange={onChange}
            value={formData.confirmPassword}
            error={formData.errors?.confirmPassword}
            type="password"
            className="sign-up-pop-up-input"
            placeholder={t("Sign.confirm_password")}
          />

          {/* {loginRequest.error && (
        <div className="wrong-credentials">{t("Sign.wrong_credentials")}</div>
      )} */}
          {false ? (
            <Loading />
          ) : (
            <button style={{ marginTop: "1em" }} onClick={handleReset}>
              {t("Sign.reset_password")}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default ResetPass;
